import { z } from "zod";

export interface AdHocSaleItemInput {
  name: string;
  quantity: number;
  unitPrice: number;
}

export function createAdHocSaleItemSchema(translate: (key: string) => string) {
  const quantityError = translate("adHocItem.validation.quantity");
  const priceError = translate("adHocItem.validation.unitPrice");
  return z.object({
    name: z.string().trim().min(1, translate("adHocItem.validation.name")),
    quantity: z.coerce.number({ invalid_type_error: quantityError })
      .finite(quantityError).int(quantityError).positive(quantityError).max(9999999, quantityError),
    unitPrice: z.coerce.number({ invalid_type_error: priceError })
      .finite(priceError).positive(priceError).max(99999999.99, priceError)
      .refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 0.000001, priceError),
  }).refine((value) => value.quantity * value.unitPrice <= 99999999.99, {
    path: ["unitPrice"], message: translate("adHocItem.validation.total"),
  });
}
